import { useQuery } from 'react-query';

// Import types
import type { TransactionDetails } from 'types/api/payments';

// Import utilities
import { useAuth } from 'components/utilities';

// Import variables
import { TRANSACTION_STATUS_TYPES } from 'helpers/variables';

// Import helpers
import { fetchLastProductPayment } from 'helpers/api/payments';

const useProductPaymentStatus = (uuid: string) => {
	const { isAuth } = useAuth();

	const { data, status } = useQuery<TransactionDetails>({
		queryKey: ['last_payment', uuid],
		queryFn: () => fetchLastProductPayment(uuid),
		enabled: isAuth,
		cacheTime: 0
	});

	const isLoading = status === 'idle' || status === 'loading';

	const continuePaymentUrl = data?.redirect_url || '';
	const isPaymentPending = data?.status === TRANSACTION_STATUS_TYPES.pending;

	return {
		isPaymentPending,
		continuePaymentUrl,
		isLoading: isAuth ? isLoading : false
	};
};

export default useProductPaymentStatus;
